export const scrollToElementFromBottom = (elementId: string) => {
  const performTextField = document.getElementById(elementId);
  if (performTextField) {
    // Verificar si el usuario está en la parte inferior de la página
    const isAtBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;

    if (isAtBottom) {
      performTextField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }
};
